import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./ViewPost.module.scss";
import { FallingLines } from "react-loader-spinner";
import axios from "../Hooks/axios";
import { useDispatch, useSelector } from "react-redux";
import { setShareData } from "../../redux/slices/tempSlice";
import { toast } from "react-toastify";
import { socket } from "../../App";
import { IoDownloadOutline, IoPencilOutline, IoCloseOutline, IoEyeOutline, IoStatsChartOutline, IoAlertCircleOutline, IoPersonRemoveOutline, IoCloseCircleOutline, IoRibbonOutline, IoEyeOffOutline, IoPersonOutline, IoBookmarkOutline } from "react-icons/io5";
import { GoArrowLeft } from "react-icons/go";

// Icons
import HeartUnfilled from "../../assets/svg/HeartUnfilled.svg";
import HeartFilled from "../../assets/svg/HeartFilled.svg";
import commentIcon from "../../assets/svg/comment.svg";
import shareIcon from "../../assets/svg/share.svg";
import DefaultProfilePic from "../../assets/images/user.png";

// Components
import Poll from "../../pages/Home/Poll";
import Avatar from "../Avatar/Avatar";
import ParsedText from "../utilis/ParsedText";
import { ReactComponent as EmojiBtnIcon } from "../../assets/icons/EmojiBtnIcon.svg";
import EmojiPicker from "emoji-picker-react";
import LeftArrow from "../../assets/svg/LeftArrowIcon.svg";
import RightArrow from "../../assets/svg/RightArrow.svg";

const CommentBox = ({ data, userId, commentId, setCommentId, handleLikeComment }) => {
    const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
    const isActive = data._id === commentId;
    return (
        <div className={`${styles.CommentBox} ${isActive ? styles.ActiveComment : ""}`}>
            <div className={styles.CBLeft}>
                <div className={styles.ImageWrapper}>
                    <Avatar src={data?.userId?.ProfilePic} name={data?.userId?.username} />
                </div>
                <div className={styles.TextWrapper}>
                    <div className={styles.Name}>{data?.userId?.username}</div>
                    <div className={styles.Text}>{data.text || data.comment}</div>
                    <div className={styles.ButtonContainer}>
                        <button onClick={() => handleLikeComment(data._id)}>
                            {data.likes?.length || 0}+ like
                        </button>
                        <button
                            style={{
                                background: isActive ? "#A6539D" : "",
                                color: isActive ? "#fff" : "",
                            }}
                            onClick={() => {
                                if (isActive) {
                                    setCommentId("");
                                } else {
                                    setCommentId(data._id);
                                }
                            }}>
                            Reply
                        </button>
                        <button onClick={() => handleLikeComment(data._id)}>{isLiked ? "Unlike" : "Like"}</button>
                        <span className={styles.Timestamp}>
                            {new Date(data.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </span>
                    </div>
                </div>
            </div>
            <div className={styles.CBRight}>
                <div onClick={() => handleLikeComment(data._id)} style={{ cursor: 'pointer' }}>
                    <img
                        src={isLiked ? HeartFilled : HeartUnfilled}
                        alt="heart"
                        style={{ width: '1.8rem', height: '1.8rem' }}
                    />
                </div>
            </div>
        </div>
    );
};

const SubCommentBox = ({ data, parentUsername, parentId, userId, commentId, setCommentId, handleLikeComment }) => {
    const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
    const isActive = data._id === commentId;
    return (
        <div className={`${styles.SubCommentBox} ${isActive ? styles.ActiveComment : ""}`}>
            <div className={styles.CBLeft}>
                <div className={styles.ImageWrapper}>
                    <Avatar src={data?.userId?.ProfilePic} name={data?.userId?.username} />
                </div>
                <div className={styles.TextWrapper}>
                    <div className={styles.Name}>{data?.userId?.username}</div>
                    <div className={styles.Text}>
                        {parentUsername && <span className={styles.MentionTag}>@{parentUsername}</span>}
                        {data.text || data.comment}
                    </div>
                    <div className={styles.ButtonContainer}>
                        <button onClick={() => handleLikeComment(data._id)}>
                            {data.likes?.length || 0}+ like
                        </button>
                        <button
                            style={{
                                background: isActive ? "#A6539D" : "",
                                color: isActive ? "#fff" : "",
                            }}
                            onClick={() => {
                                if (isActive) {
                                    setCommentId("");
                                } else {
                                    setCommentId(data._id);
                                }
                            }}>
                            Reply
                        </button>
                        <button onClick={() => handleLikeComment(data._id)}>{isLiked ? "Unlike" : "Like"}</button>
                        <span className={styles.Timestamp}>
                            {new Date(data.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </span>
                    </div>
                </div>
            </div>
            <div className={styles.CBRight}>
                <div onClick={() => handleLikeComment(data._id)} style={{ cursor: 'pointer' }}>
                    <img
                        src={isLiked ? HeartFilled : HeartUnfilled}
                        alt="heart"
                        style={{ width: '1.8rem', height: '1.8rem' }}
                    />
                </div>
            </div>
        </div>
    );
};

const ThirdLayerBox = ({ data, parentUsername, userId, handleLikeComment }) => {
    const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
    return (
        <div className={styles.ThirdLayerBox}>
            <div className={styles.CBLeft}>
                <div className={styles.ImageWrapper}>
                    <Avatar src={data?.userId?.ProfilePic} name={data?.userId?.username} />
                </div>
                <div className={styles.TextWrapper}>
                    <div className={styles.Name}>{data?.userId?.username}</div>
                    <div className={styles.Text}>
                        {parentUsername && <span className={styles.MentionTag}>@{parentUsername}</span>}
                        {data.text || data.comment}
                    </div>
                    <div className={styles.ButtonContainer}>
                        <button onClick={() => handleLikeComment(data._id)}>
                            {data.likes?.length || 0}+ like
                        </button>
                        <button onClick={() => handleLikeComment(data._id)}>{isLiked ? "Unlike" : "Like"}</button>
                        <span className={styles.Timestamp}>
                            {new Date(data.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </span>
                    </div>
                </div>
            </div>
            <div className={styles.CBRight}>
                <div onClick={() => handleLikeComment(data._id)} style={{ cursor: 'pointer' }}>
                    <img
                        src={isLiked ? HeartFilled : HeartUnfilled}
                        alt="heart"
                        style={{ width: '1.5rem', height: '1.5rem' }}
                    />
                </div>
            </div>
        </div>
    );
};

const CommentThreadItem = ({
    data,
    userId,
    commentId,
    setCommentId,
    replyId,
    setReplyId,
    setReplyMainId,
    handleLikeComment,
}) => {
    const [showReplies, setShowReplies] = useState(true);
    const hasReplies = data.Comments && data.Comments.length > 0;

    return (
        <div className={styles.ThreadContainer}>
            <CommentBox
                data={data}
                userId={userId}
                commentId={commentId}
                setCommentId={(val) => {
                    setCommentId(val);
                    setReplyMainId("");
                    setReplyId("");
                }}
                handleLikeComment={handleLikeComment}
            />

            {hasReplies && (
                <button
                    type="button"
                    className={styles.ViewRepliesBtn}
                    onClick={() => setShowReplies(!showReplies)}
                >
                    <span className={styles.RepliesLine} />
                    <span>
                        {showReplies
                            ? `▴ Hide replies (${data.Comments.length})`
                            : `↳ View ${data.Comments.length} ${data.Comments.length === 1 ? "reply" : "replies"}`}
                    </span>
                </button>
            )}

            {hasReplies && showReplies && (
                <div className={styles.RepliesWrapper}>
                    <div className={styles.ThreadLine} onClick={() => setShowReplies(false)} title="Collapse thread" />
                    {data.Comments.map((sub, sIndex) => (
                        <div key={sub._id || sIndex} className={styles.ReplyItem}>
                            <SubCommentBox
                                data={sub}
                                parentUsername={data.userId?.username}
                                parentId={data._id}
                                userId={userId}
                                commentId={replyId}
                                setCommentId={(val) => {
                                    if (val) {
                                        setReplyMainId(data._id);
                                        setReplyId(val);
                                        setCommentId("");
                                    } else {
                                        setReplyMainId("");
                                        setReplyId("");
                                    }
                                }}
                                handleLikeComment={handleLikeComment}
                            />

                            {sub.Comments && sub.Comments.length > 0 && (
                                <div className={styles.NestedRepliesWrapper}>
                                    <div className={styles.ThreadLine} />
                                    {sub.Comments.map((rep, rIndex) => (
                                        <div key={rep._id || rIndex} className={styles.ReplyItem}>
                                            <ThirdLayerBox
                                                data={rep}
                                                parentUsername={sub.userId?.username}
                                                userId={userId}
                                                handleLikeComment={handleLikeComment}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};


const ViewPost = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user, userId, token } = useSelector((state) => state.auth);

    const [postData, setPostData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLiked, setIsLiked] = useState(false);
    const [likeCount, setLikeCount] = useState(0);
    const [commentsData, setCommentsData] = useState([]);
    const [commentText, setCommentText] = useState("");
    const [showComments, setShowComments] = useState(true);
    const [userBtn, setUserBtn] = useState({ in: 0, ml: 0 });
    const [threeDotShow, setThreeDotShow] = useState(false);
    const [pollShow, setPollShow] = useState(false);
    const [zoom, setZoom] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [showReportModal, setShowReportModal] = useState(false);
    const [reportReason, setReportReason] = useState("");
    const [showBlockModal, setShowBlockModal] = useState(false);
    const [sortOrder, setSortOrder] = useState("latest");
    const [showSortDropdown, setShowSortDropdown] = useState(false);
    const [openEmoji, setOpenEmoji] = useState(false);
    const [commentId, setCommentId] = useState("");
    const [replyMainId, setReplyMainId] = useState("");
    const [replyId, setReplyId] = useState("");



    useEffect(() => {
        setIsLoading(true);
        fetchComments();
        axios
            .get(`/post/getPost/${id}`)
            .then(({ data }) => {
                console.log("Post Data => ", data);
                const targetUserId = data.userId?._id || data.userId;
                const isFollowing = user?.followingData?.includes(targetUserId) || false;
                setPostData({ ...data, isFollowing });
                setLikeCount(data?.LikeCount);
                setIsLiked(data?.isLike);
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
                toast.error("Failed to load post");
            });

        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [id, user]);

    const fetchComments = () => {
        axios.get(`/post/${id}/getcomments`).then(({ data }) => {
            setCommentsData(data.comments || []);
        }).catch(() => setCommentsData([]));
    };

    const handelLike = () => {
        if (!userId) return toast.info("Please login to like post");

        let sd = {
            notification_from: userId,
            notification_to: postData?.userId?._id,
            notification: {},
            title: "Like",
            message: `${user?.username} like your post`,
        };

        axios.post(`/post/${id}/likeANDunlike`, { userId })
            .then(({ data }) => {
                setIsLiked(data.totalLikes[0].isLike);
                setLikeCount(data.totalLikes[0].LikeCount);
                if (data.totalLikes[0].isLike) socket.emit("notification", sd);
            })
            .catch(() => {
                toast.error("Action failed");
            });
    };

    const postComment = () => {
        if (!commentText.trim()) return;

        if (replyId) {
            postReplyOnReply();
            return;
        }

        if (commentId) {
            postCommentOnComment();
            return;
        }

        let sd = {
            notification_from: userId,
            notification_to: postData?.userId?._id,
            notification: {},
            title: "Comment",
            message: `${user?.username} comment on your post`,
        };

        axios.post(`/post/${id}/comment`, {
            userId,
            text: commentText
        }).then(({ data }) => {
            setCommentText("");
            setCommentsData(data.post.Comments);
            socket.emit("notification", sd);
        }).catch(() => {
            toast.error("Failed to post comment");
        });
    };

    const postCommentOnComment = () => {
        if (!commentText.trim()) return;
        const tid = toast.loading("Replying...");
        axios.post(`/post/comment-on-comment?postId=${id}&commentId=${commentId}&userId=${userId}`, {
            text: commentText
        }).then(({ data }) => {
            toast.update(tid, { render: data.message || "Reply successful", type: "success", isLoading: false, autoClose: 2000 });
            setCommentText("");
            fetchComments();
            setCommentId("");
        }).catch((err) => {
            toast.update(tid, { render: err.response?.data?.message || "Reply failed", type: "error", isLoading: false, autoClose: 2000 });
        });
    };

    const postReplyOnReply = () => {
        if (!commentText.trim()) return;
        const tid = toast.loading("Replying...");
        axios.post(`/post/comment-on-comment?postId=${id}&commentId=${replyMainId}&userId=${userId}&replyCommentId=${replyId}`, {
            text: commentText
        }).then(({ data }) => {
            toast.update(tid, { render: data.message || "Reply successful", type: "success", isLoading: false, autoClose: 2000 });
            setCommentText("");
            fetchComments();
            setReplyMainId("");
            setReplyId("");
        }).catch((err) => {
            toast.update(tid, { render: err.response?.data?.message || "Reply failed", type: "error", isLoading: false, autoClose: 2000 });
        });
    };

    const handleSendComment = () => {
        if (replyId) {
            postReplyOnReply();
        } else if (commentId) {
            postCommentOnComment();
        } else {
            postComment();
        }
    };

    const handleLikeComment = (cId) => {
        if (!userId) return toast.info("Please login to like comments");
        axios.post(`/post/like-comment`, {
            postId: id,
            commentId: cId,
            userId
        }).then(() => {
            fetchComments();
        }).catch((err) => {
            toast.error(err.response?.data?.message || "Action failed");
        });
    };

    const getSortedComments = () => {
        if (!commentsData) return [];
        let sorted = [...commentsData];
        if (sortOrder === "latest") {
            sorted.sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0));
        } else {
            sorted.sort((a, b) => new Date(a.timestamp || 0) - new Date(b.timestamp || 0));
        }
        return sorted;
    };

    const getReplyingToUsername = () => {
        const cid = replyId || commentId;
        if (!cid || !commentsData) return null;
        const findInArray = (arr) => {
            for (const c of arr) {
                if (c._id === cid) return c.userId?.username;
                if (c.Comments) {
                    const found = findInArray(c.Comments);
                    if (found) return found;
                }
            }
            return null;
        };
        return findInArray(commentsData);
    };


    const handelDelete = () => {
        if (window.confirm("Are you sure you want to delete this post?")) {
            axios.delete(`/post/delete?postId=${id}`).then(() => {
                toast.success("Post deleted successfully");
                navigate("/Home");
            });
        }
    };

    const handleFollow = (targetId) => {
        if (!userId) return toast.info("Please login to follow users");
        axios.post("/auth/follow", { following: targetId }).then(({ data }) => {
            setPostData(prev => ({ ...prev, isFollowing: data.message === "follow" }));
            toast.success(data.message);
        }).catch(() => {
            toast.error("Action failed");
        });
    };

    const handleReport = async (targetUserId) => {
        if (!userId) return toast.info("Please login to report users");
        if (!reportReason.trim()) return toast.warn("Please provide a reason");

        try {
            await axios.post("/auth/report-user", {
                reported_user_id: targetUserId,
                reason: reportReason,
            });
            toast.success("User reported successfully");
            setReportReason("");
            setShowReportModal(false);

            setTimeout(() => {
                setShowBlockModal(true);
            }, 500);
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to report user");
        }
    };

    const handleBlock = async (targetUserId) => {
        if (!userId) return toast.info("Please login to block users");
        try {
            const { data } = await axios.post("/auth/user-action", {
                user_id: targetUserId,
                type: "block",
            });
            toast.success(data.message || "User blocked successfully");
            setShowBlockModal(false);
            setThreeDotShow(false);
            navigate("/Home");
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to block user");
        }
    };

    const checkPrivacy = (privacy) => {
        if (!privacy) return true;
        if (postData?.userId?._id === userId) return true;

        const { option, specific_users = [] } = privacy;
        const isFollowing = postData?.isFollowing || false;

        if (option === 'everyone') return true;
        if (option === 'followers') return isFollowing;
        if (option === 'followers_except') {
            const isExcluded = specific_users.some(id => (id._id || id) === userId);
            return isFollowing && !isExcluded;
        }
        if (option === 'no_one_except') {
            const isIncluded = specific_users.some(id => (id._id || id) === userId);
            return isIncluded;
        }
        return false;
    };

    const handleDownload = async (name) => {
        try {
            const media = Array.isArray(postData?.mediaUrl) ? postData.mediaUrl[userBtn.in] : postData?.mediaUrl;
            const imageUrl = typeof media === 'string' ? media : media?.url;
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${name || 'post'}.jpg`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
            setThreeDotShow(false);
            toast.success("Downloading started...");
        } catch (error) {
            console.error(error);
            toast.error("Download failed");
        }
    };

    const handleMouseDown = (e) => {
        if (zoom > 1) {
            setIsDragging(true);
            setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
        }
    };
    const handleMouseMove = (e) => {
        if (isDragging) {
            setPosition({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y });
        }
    };
    const handleMouseUp = () => setIsDragging(false);

    return (
        <div className={`App ${styles.Container}`} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp}>
            <div className={styles.BackgroundImage}>
                {postData?.mediaType === "image" ? (
                    <img src={typeof postData?.mediaUrl[userBtn.in] === 'string' ? postData?.mediaUrl[userBtn.in] : postData?.mediaUrl[userBtn.in]?.url} alt="" />
                ) : postData?.mediaType === "video" ? (
                    <video src={typeof postData?.mediaUrl[userBtn.in] === 'string' ? postData?.mediaUrl[userBtn.in] : postData?.mediaUrl[userBtn.in]?.url} autoPlay muted loop />
                ) : null}
                <div className={styles.Overlay}></div>
            </div>

            <div className={styles.ViewPost}>
                <div className={styles.Left}>
                    <div className={styles.ZoomContainer}>
                        <button onClick={() => navigate("/Home")}><GoArrowLeft /></button>
                        <div className={styles.ZoomBtns}>
                            <button disabled={zoom === 3} onClick={() => { setZoom(z => Math.min(3, z + 0.5)); setPosition({ x: 0, y: 0 }); }}>+</button>
                            <button disabled={zoom === 1} onClick={() => { setZoom(z => Math.max(1, z - 0.5)); setPosition({ x: 0, y: 0 }); }}>-</button>
                        </div>
                    </div>

                    <div className={styles.ImageContainer} style={{ position: "relative" }}>
                        {isLoading ? (
                            <FallingLines color="#3A0DBB" width="100" visible={true} ariaLabel="falling-lines-loading" />
                        ) : postData?.mediaType === "image" ? (
                            <img
                                src={typeof postData?.mediaUrl[userBtn.in] === 'string' ? postData?.mediaUrl[userBtn.in] : postData?.mediaUrl[userBtn.in]?.url}
                                alt=""
                                onMouseDown={handleMouseDown}
                                style={{
                                    transform: `translate(${position.x}px,${position.y}px) scale(${zoom})`,
                                    transition: isDragging ? "" : "all 0.3s ease-in-out",
                                    cursor: isDragging ? "grabbing" : zoom > 1 ? "grab" : "default",
                                }}
                            />
                        ) : postData?.mediaType === "video" ? (
                            <video src={typeof postData?.mediaUrl[userBtn.in] === 'string' ? postData?.mediaUrl[userBtn.in] : postData?.mediaUrl[userBtn.in]?.url} controls />
                        ) : null}

                        {postData?.mediaUrl?.length > 1 && (
                            <>
                                <button
                                    className={`${styles.MainPrevBtn} ${userBtn.in === 0 ? styles.BtnDisabled : ""}`}
                                    onClick={() => { if (userBtn.in > 0) setUserBtn({ in: userBtn.in - 1, ml: userBtn.ml + 20 }); }}
                                >
                                    <img src={LeftArrow} alt="prev" />
                                </button>
                                <button
                                    className={`${styles.MainNextBtn} ${userBtn.in === postData?.mediaUrl?.length - 1 ? styles.BtnDisabled : ""}`}
                                    onClick={() => { if (userBtn.in < postData?.mediaUrl?.length - 1) setUserBtn({ in: userBtn.in + 1, ml: userBtn.ml - 20 }); }}
                                >
                                    <img src={RightArrow} alt="next" />
                                </button>
                            </>
                        )}

                        {pollShow && <Poll setPollShow={setPollShow} postData={postData} />}
                    </div>

                    {postData?.mediaUrl?.length > 1 && (
                        <div className={styles.BottomPostContainer}>
                            <button onClick={() => { if (userBtn.in > 0) setUserBtn({ in: userBtn.in - 1, ml: userBtn.ml + 20 }); }}>
                                <img src={LeftArrow} alt="prev" />
                            </button>
                            <div className={styles.SlideImages}>
                                {postData?.mediaUrl?.map((data, index) => (
                                    <div key={index} className={`${styles.ImageWrapper} ${userBtn.in > index ? styles.inActive : ""}`} style={{ marginLeft: index === 0 ? `${userBtn.ml}%` : "", zIndex: postData?.mediaUrl?.length - index }}>
                                        {postData?.mediaType === "image" ? <img src={typeof data === 'string' ? data : data?.url} alt="" /> : <video src={typeof data === 'string' ? data : data?.url} muted />}
                                    </div>
                                ))}
                            </div>
                            <button onClick={() => { if (userBtn.in < postData?.mediaUrl?.length - 1) setUserBtn({ in: userBtn.in + 1, ml: userBtn.ml - 20 }); }}>
                                <img src={RightArrow} alt="next" />
                            </button>
                        </div>
                    )}
                </div>

                <div className={styles.Right}>
                    <div className={styles.RightTopContainer}>
                        <div className={styles.CommentWrapper}>
                            <div className={styles.UserContainer}>
                                <div className={styles.ULeft}>
                                    <div className={styles.ImageContainer}><Avatar src={postData?.userId?.ProfilePic} name={postData?.userId?.username} /></div>
                                    <div className={styles.TextWrapper}>
                                        <div className={styles.name}>{postData?.userId?.username}</div>
                                        <div className={styles.UserName}>@{postData?.userId?.username?.toLowerCase().replace(/\s/g, '')}</div>
                                    </div>
                                </div>
                                <div className={styles.URight} onClick={() => setThreeDotShow(!threeDotShow)}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
                                        <path d="M18.0577 5.30469C16.4211 5.30469 15.082 6.64375 15.082 8.28038C15.082 9.91701 16.4211 11.2561 18.0577 11.2561C19.6944 11.2561 21.0334 9.91701 21.0334 8.28038C21.0334 6.64375 19.6944 5.30469 18.0577 5.30469ZM18.0577 26.1346C16.4211 26.1346 15.082 27.4736 15.082 29.1102C15.082 30.7469 16.4211 32.0859 18.0577 32.0859C19.6944 32.0859 21.0334 30.7469 21.0334 29.1102C21.0334 27.4736 19.6944 26.1346 18.0577 26.1346ZM18.0577 15.7196C16.4211 15.7196 15.082 17.0587 15.082 18.6953C15.082 20.3319 16.4211 21.671 18.0577 21.671C19.6944 21.671 21.0334 20.3319 21.0334 18.6953C21.0334 17.0587 19.6944 15.7196 18.0577 15.7196Z" fill="white" />
                                    </svg>
                                </div>
                            </div>

                            <div className={styles.postText}>
                                <ParsedText
                                    className={styles.caption}
                                    text={`${postData?.caption || ""} ${postData?.tags
                                        ? (Array.isArray(postData.tags)
                                            ? postData.tags
                                            : (typeof postData.tags === 'string' && postData.tags.startsWith('[')
                                                ? JSON.parse(postData.tags)
                                                : []))
                                            .map(t => `#${t}`).join(" ")
                                        : ""
                                        }`}
                                />
                            </div>

                            <div className={styles.ActionContainer}>
                                {checkPrivacy(postData?.privacy?.like_view) && (
                                    <div className={styles.Like} onClick={handelLike}>
                                        <img src={isLiked ? HeartFilled : HeartUnfilled} alt="" />
                                        <p>{likeCount}</p>
                                    </div>
                                )}
                                {checkPrivacy(postData?.privacy?.comments) && (
                                    <div className={styles.Comment} onClick={() => {
                                        if (!userId) return toast.info("Please login to see comments");
                                        setShowComments(!showComments);
                                    }}>
                                        <img src={commentIcon} alt="" />
                                        <p>{commentsData?.length || 0}</p>
                                    </div>
                                )}
                                {checkPrivacy(postData?.privacy?.sharing) && (
                                    <div className={styles.Share} onClick={() => dispatch(setShareData({ show: true, endPoint: "/Post/", id: postData._id }))}>
                                        <img src={shareIcon} alt="" />
                                    </div>
                                )}
                            </div>

                            {showComments && (
                                <>
                                    <div className={styles.CommentContainer}>
                                        <div className={styles.TopBar}>
                                            <div className={styles.TopLeft}><p>Comments</p></div>
                                            <div className={styles.TopRight} onClick={() => setShowSortDropdown(!showSortDropdown)} style={{ position: 'relative', cursor: 'pointer' }}>
                                                <p>{sortOrder === "latest" ? "Latest" : "Oldest"}</p>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="23"
                                                    height="22"
                                                    viewBox="0 0 23 22"
                                                    fill="none"
                                                    style={{ transform: showSortDropdown ? 'rotate(180deg)' : 'none', transition: '0.3s' }}>
                                                    <path
                                                        d="M11.5603 13.9421L7.80664 10.1884L9.05846 8.9375L11.5603 11.4402L14.0622 8.9375L15.314 10.1884L11.5603 13.9421Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                                {showSortDropdown && (
                                                    <div className={styles.SortDropdown}>
                                                        <button onClick={(e) => { e.stopPropagation(); setSortOrder("latest"); setShowSortDropdown(false); }}>Latest</button>
                                                        <button onClick={(e) => { e.stopPropagation(); setSortOrder("oldest"); setShowSortDropdown(false); }}>Oldest</button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className={styles.BottomBar}>
                                            {getSortedComments()?.map((data, index) => (
                                                <CommentThreadItem
                                                    key={data._id || index}
                                                    data={data}
                                                    userId={userId}
                                                    commentId={commentId}
                                                    setCommentId={setCommentId}
                                                    replyId={replyId}
                                                    setReplyId={setReplyId}
                                                    setReplyMainId={setReplyMainId}
                                                    handleLikeComment={handleLikeComment}
                                                />
                                            ))}
                                        </div>
                                    </div>


                                    {checkPrivacy(postData?.privacy?.comments) && (
                                        <div className={styles.InputWrapper}>
                                            {(commentId || replyId) && (
                                                <div className={styles.ReplyingBanner}>
                                                    <p>Replying to <span>@{getReplyingToUsername()}</span></p>
                                                    <button onClick={() => { setCommentId(""); setReplyId(""); setReplyMainId(""); }}><IoCloseOutline /></button>
                                                </div>
                                            )}

                                            <div className={styles.InputAndSubmit}>
                                                <div className={styles.InputContainer}>
                                                    <input
                                                        type="text"
                                                        placeholder="Type your Comment"
                                                        value={commentText}
                                                        onChange={(e) => setCommentText(e.target.value)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter") {
                                                                handleSendComment();
                                                                setOpenEmoji(false);
                                                            }
                                                        }}
                                                    />
                                                    <button className={styles.EmojiBtn} onClick={() => setOpenEmoji(!openEmoji)}><EmojiBtnIcon /></button>
                                                </div>
                                                <button className={styles.SubmitBtn} onClick={handleSendComment}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="35" viewBox="0 0 39 35" fill="none">
                                                        <path d="M11.3335 16.7737C11.55 17.096 11.9127 17.2893 12.301 17.2893L33.4234 17.2893C34.6857 17.2893 35.0473 15.5626 33.891 15.0562L3.96144 1.94668C2.89317 1.47876 1.87598 2.69617 2.52634 3.66424L11.3335 16.7737Z" fill="white" />
                                                        <path d="M11.3335 18.5466C11.55 18.2243 11.9127 18.031 12.301 18.031L33.4234 18.031C34.6857 18.031 35.0473 19.7577 33.891 20.2641L3.96144 33.3736C2.89317 33.8415 1.87598 32.6241 2.52634 31.6561L11.3335 18.5466Z" fill="white" />
                                                    </svg>
                                                </button>
                                            </div>
                                            {openEmoji && (
                                                <div className={styles.EmojiContainer}>
                                                    <EmojiPicker onEmojiClick={(e) => setCommentText(prev => prev + e.emoji)} theme="dark" />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}


                        </div>
                    </div>
                </div>

                {threeDotShow && (
                    <div className={styles.ThreeDotWrapper} onClick={() => setThreeDotShow(false)}>
                        <div className={styles.ButtonWrapper} onClick={(e) => e.stopPropagation()}>
                            {userId === postData?.userId?._id ? (
                                <>
                                    <button onClick={handelDelete}><IoCloseOutline /> Remove</button>
                                    <button onClick={() => navigate(`/EditPost/${id}`)}><IoPencilOutline /> Edit</button>
                                    {postData?.Enabledpoll && <button onClick={() => { setPollShow(true); setThreeDotShow(false); }}><IoEyeOutline /> View Poll</button>}
                                    <button onClick={() => handleDownload(postData?.userId?.username)}><IoDownloadOutline /> Download</button>
                                    <button onClick={() => navigate("/PostVisit")}><IoStatsChartOutline /> View Stats</button>
                                </>
                            ) : (
                                <>
                                    <button onClick={() => { setShowReportModal(true); setThreeDotShow(false); }}><IoAlertCircleOutline /> Report</button>
                                    <button onClick={() => { setShowBlockModal(true); setThreeDotShow(false); }}><IoPersonRemoveOutline /> Block user</button>
                                    <button onClick={() => toast.info("Coming Soon")}><IoCloseCircleOutline /> Remove mention</button>
                                    <button onClick={() => toast.info("Coming Soon")}><IoRibbonOutline /> Set to high supremacy</button>
                                    <button onClick={() => toast.info("Coming Soon")}><IoEyeOffOutline /> Hide this post</button>
                                    <button onClick={() => handleFollow(postData?.userId?._id)}>
                                        <IoPersonOutline /> {postData?.isFollowing ? "Un-follow" : "Follow"}
                                    </button>
                                    <button onClick={() => toast.info("Coming Soon")}><IoBookmarkOutline /> Save</button>
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* Report Modal */}
            {showReportModal && (
                <div className={styles.ModalOverlay}>
                    <div className={styles.ModalContent}>
                        <h2>Report User</h2>
                        <p>Please specify the reason for reporting this user.</p>
                        <textarea
                            placeholder="Type your reason here..."
                            value={reportReason}
                            onChange={(e) => setReportReason(e.target.value)}
                        ></textarea>
                        <div className={styles.ModalButtons}>
                            <button className={styles.CancelBtn} onClick={() => setShowReportModal(false)}>Cancel</button>
                            <button className={styles.SubmitBtn} onClick={() => handleReport(postData?.userId?._id)}>Submit Report</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Block Modal */}
            {showBlockModal && (
                <div className={styles.ModalOverlay}>
                    <div className={styles.ModalContent}>
                        <h2>Block User</h2>
                        <p>Are you sure you want to block this user? You won't see their posts or be able to interact with them.</p>
                        <div className={styles.ModalButtons}>
                            <button className={styles.CancelBtn} onClick={() => setShowBlockModal(false)}>Cancel</button>
                            <button className={styles.BlockBtn} onClick={() => handleBlock(postData?.userId?._id)}>Block User</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewPost;


